import {
  Directive,
  ElementRef,
  Input,
  Optional,
  Renderer2,
  Self,
} from '@angular/core';
import {
  LayoutAlignDirective as FlexLayoutLayoutAlignDirective,
  MediaMonitor,
} from '@angular/flex-layout';
import { LayoutDirective } from './layout.directive';

@Directive({
  selector: `
    [flLayoutAlign],
    [flLayoutAlign.mobile],
    [flLayoutAlign.tablet],
    [flLayoutAlign.desktop-small],
    [flLayoutAlign.desktop-large],
    [flLayoutAlign.desktop-xlarge],
    [flLayoutAlign.desktop-xxlarge],
  `,
})
export class LayoutAlignDirective extends FlexLayoutLayoutAlignDirective {
  constructor(
    monitor: MediaMonitor,
    elRef: ElementRef,
    renderer: Renderer2,
    @Optional()
    @Self()
    container: LayoutDirective,
  ) {
    super(monitor, elRef, renderer, container);
  }

  @Input('flLayoutAlign')
  set layoutAlign(val: any) {
    this._cacheInput('align', val);
  }
  @Input('flLayoutAlign.mobile')
  set layoutAlignMobile(val: any) {
    this._cacheInput('alignMobile', val);
  }
  @Input('flLayoutAlign.tablet')
  set layoutAlignTablet(val: any) {
    this._cacheInput('alignTablet', val);
  }
  @Input('flLayoutAlign.desktop-small')
  set layoutAlignDesktopSmall(val: any) {
    this._cacheInput('alignDesktopSmall', val);
  }
  @Input('flLayoutAlign.desktop-large')
  set layoutAlignDesktopLarge(val: any) {
    this._cacheInput('alignDesktopLarge', val);
  }
  @Input('flLayoutAlign.desktop-xlarge')
  set layoutAlignDesktopXLarge(val: any) {
    this._cacheInput('alignDesktopXLarge', val);
  }
  @Input('flLayoutAlign.desktop-xxlarge')
  set layoutAlignDesktopXXLarge(val: any) {
    this._cacheInput('alignDesktopXXLarge', val);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/it/webapp/src/app/@shared/ui/layout/layout-align.directive.ts